<h3>are you sure you want to delete this price ?? </h3>


<div mat-dialog-actions>
  <button class="button" mat-button [type]="submit" [mat-dialog-close]="1" (click)="confirmDelete()">Delete</button>
  <button class="button" mat-button (click)="onNoClick()" tabindex="-1">Cancel</button>
</div>
